import React from 'react';
import tastify from '@frontastic/catwalk/js/helper/tastify';
import StoreDetail from '../../../components/organisms/storeLocator/StoreDetail';

function StoreDetails(props) {
  const { stream } = props.data;

  if (!stream) return null;

  const formattedData = {
    ...stream,
    coordinates: {
      lat: Number(stream?.coordinates?.lat),
      lng: Number(stream?.coordinates?.lng),
    },
  };

  return <StoreDetail chosenStore={formattedData} showCanonicalLink={props?.node?.configuration?.showCanonicalLink} />;
}

export default tastify()(StoreDetails);
